import React, { useEffect, Fragment } from "react";
import Breadcrumb from "../../common/breadcrumb";

import EventCharts from "./eventCharts";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const Default = () => {

  const navigate = useNavigate();

  const company = useSelector(
    state => state?.authReducer?.company || null
  );

  const financialYear = useSelector(
    state => state?.authReducer?.financialYear || null
  );

  useEffect(() => {
    console.log('company', company, 'financialYear', financialYear);
    if(!company){
      navigate('/company-selection');
      return
    }

    if(!financialYear){
      navigate('/financial-year-selection');
      return
    }
  }, [company, financialYear]);

  return (
    <Fragment>
      <Breadcrumb parent="Dashboard" title="Dashboard" />
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-8 xl-100">
            <div className="row">
              <EventCharts />
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Default;
